import { Card } from "@mui/material";

const CustomCard = ({ children = <></>, className = '', style = {}, sx = {} }) => {
    return (
        <Card
            className={`custom-card ${className}`}
            sx={{
                borderRadius: '14px',
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
                ...style,
                ...sx,
            }}
        >
            {children}
        </Card>
    );
}

export default CustomCard;